module.exports = __webpack_public_path__ + "static/img/11.eeea60a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/11.png
// module id = 9i8Q
// module chunks = 0